import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";
import { ActionButtonContainer } from "../ViewFile.styles";

export const RemoveButtonContainer = styled(ActionButtonContainer)<{ confirmationOpened: boolean }>(
    props => props.confirmationOpened && { color: theme(props).icons.hoverColor }
);

export const TooltipMessageContent = styled.div(props => ({
    position: "relative",
    zIndex: 1000,
    width: 212,
    fontSize: theme(props).typography.primary.fontSize.css(),
}));

export const TooltipText = styled.div({
    marginBottom: 10,
});

export const ButtonDelimiter = styled.span({
    marginLeft: 10,
});
